import { EmailIcon, FacebookIcon, TwitterIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useShareLinks } from './hooks/useShareLinks';
import type { Channel } from './hooks/useShareLinks';

const ICON_MAP = {
	twitter: TwitterIcon,
	facebook: FacebookIcon,
	email: EmailIcon,
};
const I18N_MAP: Record<Channel, TranslationKey> = {
	twitter: translationKey('corgi.petition_guides_article.page_heading.share.twitter.button_label'),
	facebook: translationKey('corgi.petition_guides_article.page_heading.share.facebook.button_label'),
	email: translationKey('corgi.petition_guides_article.page_heading.share.email.button_label'),
};

export function ShareLinks() {
	const {
		data: { shareActions },
	} = useShareLinks();

	const { translate } = useI18n();

	return (
		<div className="flex gap-4">
			{shareActions.map(({ channel, action }) => {
				const IconComponent = ICON_MAP[channel];
				return (
					<button
						aria-label={translate(I18N_MAP[channel])}
						className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-stroke-primary"
						key={channel}
						data-testid={`article-share-${channel}`}
						data-qa={`article-share-${channel}`}
						type="button"
						onClick={action}
					>
						<IconComponent />
					</button>
				);
			})}
		</div>
	);
}
